import {StyleSheet, View} from "@react-pdf/renderer";
import {ClassTableHeader} from "./ClassTableHeader";
import {ClassTableRow} from "./ClassTableRow";
import {HSZG_MAIN_COLOR} from "../../../../config/style/colors";

const styles = StyleSheet.create({
    tableContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        borderWidth: 1.5,
        borderColor: HSZG_MAIN_COLOR,
    },
});

export const ClassPdfTable = (props) => {
    return (
        <View style={styles.tableContainer}>
            <ClassTableHeader/>
            <ClassTableRow rows={props.rows}/>
        </View>
    );
}

